define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/xml",
	"./ProductType"
], function(declare,lang,def,Field,xml,ProductType) {

	return declare(null, {
		_addBomField: function(/*Node*/style, /*def.View*/formView) {
			// summary: add checkbox field to form for adding new colorway to BOM(s)
			if (ProductType.hasTDS(style, "ApparelBOM")) {
				formView.m_fields.push(lang.mixin(new Field(), {
					m_label: "ColorwayAddToBom",
					m_typeControl: def.FIELD_CHECKBOX,
					bPersist: true
				}));
			}
		},

		_writeBomField: function(/*String*/urlStyle, /*String*/urlColorway) {
			// summary: call method to add to BOM
			var	b = this.m_formData.getFieldValue("ColorwayAddToBom");
			if (b) {
				this.m_writer.callMethod("Apparel", "AddColorwayToBOM")
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, urlStyle)
					.addParameter(xml.PROP_URL, xml.ATTR_REF, urlColorway);
			}
		}
	});
});